// Centralized verbatim copy for the Share Trivvy modals.
// Keep all sharing-related user-facing strings here so they are defined once
// and reused across the share components (no inline duplication).

export const SHARE_RESHARE_TRIVVY = "Share/Reshare Trivvy";

// ---- Top info banner (Email a Link / Text a Link / Text only) ----
// Line 1 wraps an inline "Users List" chip, so the surrounding copy is split
// into a leading and trailing segment around that chip.
export const SHARE_BANNER_LINE1_LEAD =
  "To share a Trivvy with users on this platform, first open the";
export const SHARE_BANNER_LINE1_TAIL =
  "in the top right and upload a file or invite them. Then return here to share.";
export const SHARE_BANNER_LINE2 =
  "Otherwise, go back to the previous screen to share another way.";
export const SHARE_USERS_LIST_CHIP = "Users List";

// ---- In-card permissions Note footer ----
export const SHARE_NOTE_LABEL = "Note:";
export const SHARE_NOTE_PUBLIC_LINK =
  "This means anyone with the link can receive the Trivvy.";

// ---- "Select users" section heading + subtitles ----
export const SHARE_SELECT_USERS_HEADING = "Select users to share this Trivvy";
export const SHARE_SECTION_SUBTITLE_SMS =
  "Choose a recipient group, then send or reshare below.";
export const SHARE_SECTION_SUBTITLE_FILTER =
  "Pick all users or narrow the list using filters below.";

// ---- Select-all pill ----
export const SHARE_SELECT_ALL_USERS = "Select all users";
export const SHARE_DESELECT_ALL_USERS = "Deselect to remove all users";

// ---- Segmented tab labels ----
export const SHARE_TAB_NEW_USERS = "New Users";
export const SHARE_TAB_ALREADY_SAVED = "Already saved";

// ---- Export CSV pill ----
export const SHARE_EXPORT_CSV = "Export CSV";

// ---- Pagination prev/next controls ----
export const SHARE_PAGINATION_PREVIOUS = "Previous";
export const SHARE_PAGINATION_NEXT = "Next";

// ---- Share Outcomes modal delivery note ----
export const SHARE_OUTCOMES_DELIVERY_NOTE =
  "Outcomes will be shared using the same delivery method as the survey.";
